import { render, staticRenderFns } from "./ProductCombo.vue?vue&type=template&id=5ea50dcc&"
import script from "./ProductCombo.vue?vue&type=script&lang=js&"
export * from "./ProductCombo.vue?vue&type=script&lang=js&"
import style0 from "./ProductCombo.vue?vue&type=style&index=0&id=5ea50dcc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports